<template>
  <div id="notfound">
    <div class="notfound">
      <div class="notfound-404">
        <img v-if="this.$store.getters.brand.image !== undefined" :src="this.$store.getters.brand.image">
      </div>
      <br>
      <h2>Something error!</h2>
      <p>
        {{ message }}
        <br> <br>
        <a href="/">Return </a>
      </p>
    </div>
  </div>
</template>

<script>
import '@/assets/error.css'

export default {
  name: 'Critical',
  data() {
    return {
      message: 'The page you are looking for might have some problem, please return and try again.'
    }
  },
  mounted() {
    if (this.$store.getters.errorMessage) {
      this.message = this.$store.getters.errorMessage
      this.$store.commit('SET_ERROR_MESSAGE', null)
    }
    document.body.classList.add('error_body')
  },
  destroyed() {
    document.body.classList.remove('error_body')
  }
}
</script>

<style scoped>
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
</style>
